import moment from "moment";
import { isDateClosedOutForRoom } from "../../modules/isDateClosedOutForRoom";
import { getMinStayForDate } from "../../../../../utils/getMinStayForDate";

export const MinStayManagement = (props) => {
  const {
    dateColumns,
    currentMonth,
    selectedYear,
    minimumStay,
    handleCellClick,
    ratePlanId,
    roomId,
    closeout,
  } = props;
  return (
    <tr>
      <td className="sticky-column weekend-highlight">
        <strong>Min Stay</strong>
      </td>
      {dateColumns.map((date) => {
        const day = moment(date, "DD MMM").date();
        const dateKey = moment(
          `${day}-${currentMonth.month() + 1}-${selectedYear}`,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY");
        const minStayArray = minimumStay[roomId]?.[dateKey] || [];
        const minStayForDate = getMinStayForDate({
          minimumStays: minStayArray,
          selectedRatePlanId: ratePlanId,
        });
        return (
          <td
            key={`${roomId}-${date}-minimumstay`}
            className="availability-cell"
            onClick={() =>
              handleCellClick(roomId, dateKey, ratePlanId, "minimumStay")
            }
            style={{
              cursor: "pointer",
              backgroundColor: isDateClosedOutForRoom(roomId, dateKey, closeout)
                ? "#f4e736"
                : "transparent",
            }}
          >
            <div>{minStayForDate || "N/A"}</div>
          </td>
        );
      })}
    </tr>
  );
};
